export default {"src":"/_next/static/media/ImagePlaceholder.5fc8649f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};